import styled from  'styled-components';

export const StyledApprovelDetail = styled.div`
  ${({theme}) => `
      .group-btn {
        margin-top: ${theme.uptimeSpace[7]}px;
        .hlx-btn {
          margin-right: ${theme.uptimeSpace[10]}px;
        }
      }
  `}
`;

